import { render } from "./VisitorManagement.vue?vue&type=template&id=15c943d8&scoped=true"
import script from "./VisitorManagement.vue?vue&type=script&lang=js"
export * from "./VisitorManagement.vue?vue&type=script&lang=js"

import "./VisitorManagement.vue?vue&type=style&index=0&id=15c943d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c943d8"]])

export default __exports__